<script>

import { mapState } from 'vuex'
import bus from 'vue3-eventbus'
import http from '@/utils/http'
import toast from '@/utils/toast'
import lottie from 'lottie-web'
import request from '@/utils/request'

export default {
  props: {
    indexData: Object
  },
  methods: {
    dismissDialog () {
      this.$emit('task')
    },
    showShareTips () {
      this.dismissDialog()
      this.$store.commit('shareTip', true)
    },
    startCountdown (seconds) {

      // 清理旧timer
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }

      this.remainSeconds = seconds

      if (seconds <= 0) {
        return
      }

      this.timer = setInterval(() => {

        if (this.remainSeconds > 0) {

          this.remainSeconds--

        } else {

          clearInterval(this.timer)
          this.timer = null

        }

      }, 1000)

    },

    pad (num) {
      return String(num).padStart(2, '0')
    },
    claimTask(itemDto,index) {
      if(itemDto.finished){
        const requestBody = {
          pn: this.pn,
          aid: this.aid,
          pkg: this.pkg,
          uid: this.uid,
          code: this.code,
          channel: this.channel,
          region: 'US',
          channelid:this.channel,
          prizeTaskV2Id:itemDto.prizeTaskV2Id
        }
        http.postHttp(`/landscape/region/taskV2/claimTaskItem`,requestBody)
          .then((resp) => {
            if (resp.code !== 0) {
              return
            }
            if(resp && resp.data && resp.data.claimStatus){
              
              this.clickClaim = false
              
              this.setAnim(require(`@/assets/coins${index + 1}.json`))
            }
          })
      }else{
        this.clickClaim = true
      }
    },
    receive(){

        const requestBody = {
          pn: this.pn,
          aid: this.aid,
          pkg: this.pkg,
          uid: this.uid,
          code: this.code,
          channel: this.channel,
          region: 'US',
          channelid:this.channel,
        }
        http.postHttp(`/landscape/region/taskV2/claimTaskRounds`,requestBody)
          .then((resp) => {
            if (resp.code !== 0) {
              return
            }
            if(resp && resp.data && resp.data.claimStatus){
              bus.emit('taskAllClaim', resp.data)
            }
          })
    },
    whatsappClick() {
      http.reportEvent("us_newtask_wa_share","")
      const whatsApp = this.getShareDataByPkg('com.whatsapp')
      if (!whatsApp) {
        return
      }
      this.reportShare('WA')

      if (window.jskit && window.jskit.share) {
        if(window.jskit.startPortraitPage){
          window.jskit.share('com.whatsapp', JSON.stringify(whatsApp))
        }else{
          window.jskit.share('com.whatsapp', whatsApp.link)
        }
        return
      }
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.share) {
        window.webkit.messageHandlers.share.postMessage({
          platform: 'com.whatsapp',
          link: whatsApp.link
        })
        return
      }
      let _href = 'https://api.whatsapp.com/send?'
      const text = whatsApp.link
      const link = whatsApp.img
      _href += '&text=' + encodeURIComponent(text)
      _href += '&img=' + encodeURIComponent(link)
      window.open(_href)
    },
    moreClick() {
      http.reportEvent("us_newtask_more_share","")
      const shareData = this.getShareDataByPkg('default')
      if (!shareData) {
        return
      }
      
      this.reportShare('other')

      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.share) {
        window.webkit.messageHandlers.share.postMessage({
          platform: '',
          link: shareData.link
        })
        return
      }

      if (window.jskit && window.jskit.share) {
        if(window.jskit.startPortraitPage){
          window.jskit.share('system', JSON.stringify(shareData))
        }else{
          window.jskit.share('', shareData.link)
        }
        window.jskit.showToast('Share Success')
        return
      }

      if (navigator.canShare) {
        navigator.share({
          title: 'Share',
          text: shareData.link
        })
      } else {
        toast.show('Your browser does not support sharing')
      }
    },
    getShareDataByPkg (pkg) {
      const shareData = this.$store.state.shareData
      for (const index in shareData) {
        const item = shareData[index]
        if (item.platform === pkg) {
          return item
        }
      }
    },
    reportShare (platform) {

        const requestBody = {
          pn: this.pn,
          aid: this.aid,
          pkg: this.pkg,
          uid: this.uid,
          code: this.code,
          channel: this.channel,
          region: 'US',
          channelid:this.channel,
          platform:platform,
          shareId:""
        }
        http.postHttp(`/landscape/region/taskV2/share?code=${this.code}&pn=${this.pn}&platform=${platform}&platform=${platform}&shareId=${''}&region=${'US'}`,requestBody)
          .then((resp) => {
            bus.emit('refresh', true)
          })
    },
    openState(itemDto){
      if(itemDto.finished && itemDto.claimed){
        return "open"
      }else{
        if(this.currentTaskId == itemDto.prizeTaskV2Id){
          return "selected"
        }
        return "close"
      }
    },
    setAnim(anim){
      if (this.lottieAnim) {
        this.lottieAnim.destroy()
        this.lottieAnim = null
      }
      this.lottieAnim = lottie.loadAnimation({
        container: this.$refs.fullAnim,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        animationData: anim
      })

      this.lottieAnim.addEventListener('complete', () => {
        console.log('动画播放结束')
        bus.emit('refresh', true)
      })
      this.lottieAnim.play()
    },
    isSelected(itemDto){
      return this.currentTaskId == itemDto.prizeTaskV2Id
    }
  },
  mounted () {
    http.reportEvent("us_newtask_show","")
  },
  computed: {
    ...mapState(['pn', 'aid', 'pkg', 'uid', 'channel', 'code']),

    taskData() {
      return this.$store.state.taskData?.data
    },
    round() {
      return this.taskData?.taskRound || 1
    },
    tvTotalReward() {
      return "$ " + (this.taskData?.claimAmount || 0)
    },
    tvSubtitle() {
      return this.taskData?.subtitle
    },
    roundTips() {
      return this.taskData?.roundTips.replace(
        /\$.*$/,
        '<span style="color:#FFE400">$&</span>'
      )
      // return this.taskData?.roundTips
    },
    popupBalanceTips() {
      return this.taskData?.popupBalanceTips
    },
    countdownText () {

      const hours = Math.floor(this.remainSeconds / 3600)

      const minutes = Math.floor(
        (this.remainSeconds % 3600) / 60
      )

      const seconds = this.remainSeconds % 60

      return `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`
    },

    expiredSecond () {
      return this.taskData?.expiredSecond || 0
    },
    taskItemList () {
      return this.taskData?.taskItemList || []
    },
    showAllClaim () {
      return this.taskItemList[3]?.claimed || false
    }
  },
  data () {
    return {
      taskPics: [require('@/assets/task_nomal.png'), require('@/assets/task_pass.png')],
      taskAward: [5, 5, 10, 15, 20],
      showClaim:false,
      timer: null,
      remainSeconds: 0,
      currentTaskId : 0,
      clickClaim : false,
      lottieAnim: null
    }
  },

  watch: {

    // 监听 computed
    expiredSecond: {

      immediate: true,

      handler (val) {

        this.startCountdown(val)

      }

    },
    
    taskItemList: {
      handler (newVal) {
        const item = newVal?.find(item => !item.claimed)

        if (item) {
          this.currentTaskId = item.prizeTaskV2Id
        }else{
          this.currentTaskId = 0
        }
      },
      immediate: true
    }

  },
}
</script>

<template>
  <div :class="`bg-${round}`">
    <div :class="`balance-${round}`">$ {{ indexData ? indexData.data.showBalance.toFixed(2) : '' }}</div>
    <div v-if="popupBalanceTips" :class="`bubble-${round} up`">{{popupBalanceTips}}</div>
    <div :class="`title-${round}`" ></div>
    <div :class="`bg-reward-${round}`">
      <div class="reward">{{ tvTotalReward }}</div>
      <div class="reward-tips">{{ tvSubtitle }}</div>
    </div>

    <div :class="`task-tips-${round}`" v-html="roundTips"></div>
    
    <div class="box-wrap">
      <div
        v-for="(item, index) in taskItemList"
        :key="index"
        class="box-content"
      >

          <div v-if="item.tips && isSelected(item) && clickClaim" :class="`bubble-tips-${round} down`">{{item.tips}}</div>

          <div v-if="isSelected(item) && !clickClaim" class="hand"></div>
          <div :class="`box-${round}-${openState(item)}`"></div>
          <div :class="`box-base-${round}`">
            <div v-if="!isSelected(item)" :class="`box-reward-${round}`">{{ item?.claimed? '$' + item?.rewardAmount:'?' }}</div>
            <div v-if="isSelected(item)" class="claim" @click="claimTask(item,index)">Claim</div>
          </div>

      </div>
    </div>

    <div :class="`time-${round}`" ><img style="width: 2.7rem;height: 2.6rem;margin-right: 1rem;" src="@/assets/iv_clock.png">End of this reward <p style="color: #FF0;">{{ countdownText }}</p></div>


    <div class="share">
      <div v-if="clickClaim" class="share-hand"></div>
      <div v-if="!showAllClaim" class="share-friends" @click="moreClick">
        <img class="share-friends-icon" src="@/assets/iv_share_more.png" />
        <span>Share With Friends</span>
      </div>
      <div v-if="showAllClaim" class="receive" @click="receive">Receive</div>
    </div>
  </div>
  
  <div ref="fullAnim" class="fullAnim"></div>
</template>

<style scoped>
.receive{
  position: absolute;
  background-image: url("@/assets/btn_claim.png");
  background-size: 100% 100%;
  width: 28.4rem;
  height: 9rem;
  margin-left: 5rem;
  align-content: center;
  justify-content: center;
  text-align: center;
  font-family: AvertaStd-ExtraBold;
  font-size: 2.8rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  color: #FFF;
}
.hand{
  position: absolute;
  background-image: url("@/assets/hand.png");
  background-size: 100% 100%;
  width: 8.9rem;
  height: 9.3rem;
  z-index: 10;
  margin-top: 16rem;
  margin-left: 7rem;
  pointer-events: none;
  animation: fingerMove 1.2s infinite ease-in-out;
}
@keyframes fingerMove {
  0% {
    transform: translate(0, 0);
  }

  50% {
    transform: translate(1rem, 1rem);
  }

  100% {
    transform: translate(0, 0);
  }
}
.share-hand{
  position: absolute;
  background-image: url("@/assets/hand.png");
  background-size: 100% 100%;
  width: 8.9rem;
  height: 9.3rem;
  z-index: 10;
  margin-left: 15rem;
  margin-top: 5rem;
  pointer-events: none;
  animation: fingerMove 1.2s infinite ease-in-out;
}
.bg-1 {
  width: 94.8rem;
  height: 55.6rem;
  align-self: start;
  background-image: url("@/assets/bg_task1.png");
  background-size: 100% 100%;
  margin-top: 6rem;
  position: relative;
  display: flex;
  flex-direction: column;
}
.bg-2 {
  width: 94.8rem;
  height: 55.6rem;
  align-self: start;
  background-image: url("@/assets/bg_task2.png");
  background-size: 100% 100%;
  margin-top: 6rem;
  position: relative;
  display: flex;
  flex-direction: column;
}
.title-1 {
  width: 68.7rem;
  height: 5.8rem;
  background-image: url("@/assets/title_task1.png");
  background-size: 100% 100%;
  position: relative;
  align-self: center;
  justify-self: center;
  margin-top: -1rem;
}
.title-2 {
  width: 68.7rem;
  height: 5.8rem;
  background-image: url("@/assets/title_task2.png");
  background-size: 100% 100%;
  position: relative;
  align-self: center;
  justify-self: center;
  margin-top: -1rem;
}
.balance-1 {
  width: 17.6rem;
  height: 10.3rem;
  background-image: url("@/assets/mybalance1.png");
  background-size: 100% 100%;
  margin-left: -15rem;
  margin-top: 2rem;
  position: absolute;
  font-size: 3.4rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color:  #FFCA34 ;
  align-content: center;
  justify-content: center;
  text-align: center;
  padding-top: 3rem;
  
  display: flex;
  justify-items: center;
  align-items: center;
}
.balance-2 {
  width: 17.6rem;
  height: 10.3rem;
  background-image: url("@/assets/mybalance2.png");
  background-size: 100% 100%;
  margin-left: -15rem;
  margin-top: 2rem;
  position: absolute;
  font-size: 3.4rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color:  #FFCA34 ;
  align-content: center;
  justify-content: center;
  text-align: center;
  padding-top: 3rem;
  
  display: flex;
  justify-items: center;
  align-items: center;
}
.share {
  width: 40rem;
  height: 8.6rem;
  display: flex;
  flex-direction: row;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -6rem;
  justify-content: center;
  align-content: center;
  justify-items: center;
  align-items: center;
}
/* Share With Friends：单个绿色长条，点击拉起系统分享（moreClick）
   背景用设计稿切图 bg_share_newtask.png（371x88，比例 4.216，按比例设尺寸避免圆角拉伸）*/
.share-friends {
  /* 按钮尺寸严格按切图比例(371x88≈4.216)，避免 background 拉伸变形；
     两侧留白靠缩小内部图标/文字来实现 */
  flex: none;
  width: 36.3rem;
  height: 8.6rem;
  background-image: url("@/assets/bg_share_newtask.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.4rem;
  color: #FFF;
  font-size: 2.8rem;
  font-weight: 600;
  line-height: normal;
}

.share-friends:active {
  opacity: 0.6;
}

.share-friends-icon {
  width: 3.06rem;
  height: 3.2rem;
  /* 素材是绿色图标，滤成白色以贴合绿色按钮（后续若换成白色图标可去掉 filter）*/
  filter: brightness(0) invert(1);
}

.bg-reward-1{
  margin-top: 2.2rem;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
  justify-self: center;
  align-self: center;
  width: 45rem;
  height: 9.2rem;
  background-image: url("@/assets/bg_taskreward1.png");
  background-size: 100% 100%;
}
.bg-reward-2{
  margin-top: 2.2rem;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
  justify-self: center;
  align-self: center;
  width: 45rem;
  height: 9.2rem;
  background-image: url("@/assets/bg_taskreward2.png");
  background-size: 100% 100%;
}
.reward {
  text-align: center;
  font-size: 3.4rem;
  margin-top: 1.8rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  background: linear-gradient(180deg, #FFFF0D 0%, #FFCA34 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.reward-tips {
  color: #FFF;
  text-align: center;
  font-size: 2rem;
  font-weight: 600;
  margin-top: -0.5rem;
  text-shadow:
    1px 0 #A20E59,
    -1px 0 #A20E59,
    0 1px #A20E59,
    0 -1px #A20E59;
}

.task-tips-1 {
  color: #FFCFF5;
  padding-top: 1rem;
  font-size: 2rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  width: 49.2rem;
  height: 6.7rem;
  align-self: center;
  justify-self: center;
  justify-items: center;
  align-items: center;
  background-image: url("@/assets/bg_tasktips1.png");
  background-size: 100% 100%;
  text-align: center;
}
.task-tips-2 {
  color: #FFCFF5;
  padding-top: 1rem;
  font-size: 2rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  width: 49.2rem;
  height: 6.7rem;
  align-self: center;
  justify-self: center;
  background-image: url("@/assets/bg_tasktips2.png");
  background-size: 100% 100%;
  text-align: center;
}
.box-wrap {
  width: 90%;
  height: auto;
  display: flex;
  flex-direction: row;
  margin-top: 3rem;
  align-self: center;
  justify-self: center;
}
.box-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
}
.box-1-close {
  width: 15.8rem;
  height: 11.1rem;
  background-image: url("@/assets/box_close_task1.png");
  background-size: 100% 100%;
  z-index: 1;
}
.box-1-selected {
  width: 15.8rem;
  height: 11.1rem;
  background-image: url("@/assets/box_close_task1_selected.png");
  background-size: 100% 100%;
  z-index: 1;
}
.box-1-open {
  width: 15.6rem;
  height: 15.4rem;
  background-image: url("@/assets/box_open_task1.png");
  background-size: 100% 100%;
  margin-top: -4.3rem;
  z-index: 1;
}
.box-2-close {
  width: 15.8rem;
  height: 11.1rem;
  background-image: url("@/assets/box_close_task2.png");
  background-size: 100% 100%;
  z-index: 1;
}
.box-2-selected {
  width: 15.8rem;
  height: 11.1rem;
  background-image: url("@/assets/box_close_task2_selected.png");
  background-size: 100% 100%;
  z-index: 1;
}
.box-2-open {
  width: 15.6rem;
  height: 15.4rem;
  margin-top: -4.3rem;
  background-image: url("@/assets/box_open_task2.png");
  background-size: 100% 100%;
  z-index: 1;
}
.box-base-1 {
  width: 16.8rem;
  height: 15.9rem;
  margin-top: -4rem;
  background-image: url("@/assets/base_task1.png");
  background-size: 100% 100%;
  z-index: 0;
  display: flex;
  align-items: center;
  justify-items: center;
  align-content: center;
  justify-content: center;
}
.box-base-2 {
  width: 16.8rem;
  height: 15.9rem;
  margin-top: -4rem;
  background-image: url("@/assets/base_task2.png");
  background-size: 100% 100%;
  z-index: 0;
  display: flex;
  align-items: center;
  justify-items: center;
  align-content: center;
  justify-content: center;
}
.box-reward-1 {
  width: 7.1rem;
  height: 3.2rem;
  background-image: url("@/assets/bg_box_reward1.png");
  background-size: 100% 100%;
  justify-content: center;
  align-content: center;
  text-align: center;
  margin-top: 3.5rem;
  color: #FFF;
  font-size: 2.4rem;
}
.box-reward-2 {
  width: 7.1rem;
  height: 3.2rem;
  background-image: url("@/assets/bg_box_reward2.png");
  background-size: 100% 100%;
  justify-content: center;
  align-content: center;
  text-align: center;
  margin-top: 3.5rem;
  color: #FFF;
  font-size: 2.4rem;
}
.claim {
  width: 12rem;
  height: 4.75rem;
  background-image: url("@/assets/bg_claim.png");
  background-size: 100% 100%;
  justify-content: center;
  align-content: center;
  text-align: center;
  margin-top: 3.5rem;
  color: #FFF;
  font-size: 2rem;
  display: flex;
  font-weight: 600;
  justify-items: center;
  align-items: center;
}
.claim:active {
  opacity: 0.6;
}
.time-1 {
  width: auto;
  height: 2.6rem;
  color: #FFF;
  font-size: 2rem;
  font-weight: 600;
  line-height: normal;
  z-index: 2;
  align-self: center;
  justify-self: center;
  background-image: url("@/assets/time_round1.png");
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  margin-top: 2rem;
}
.time-2 {
  width: auto;
  height: 2.6rem;
  color: #FFF;
  font-size: 2rem;
  font-weight: 600;
  line-height: normal;
  z-index: 2;
  align-self: center;
  justify-self: center;
  background-image: url("@/assets/time_round2.png");
  background-size: 100% 100%;
  display: flex;
  align-items: center;
}
.bubble-1 {
  min-width: 20rem;
  padding: 1rem;
  background: rgba(64, 1, 87, 0.90);

  border-radius: 1.2rem;
  position: absolute;

  margin-left: -15rem;
  margin-top: 13rem;

  border: 0.25rem solid #CD68F7;
  color: #E47CFF;
  font-size: 2rem;
  z-index: 10
}
.bubble-1.up::before {
  content: '';

  position: absolute;

  top: -1.4rem;
  left: 2.8rem;

  width: 0;
  height: 0;

  border-left: 1.2rem solid transparent;
  border-right: 1.2rem solid transparent;
  border-bottom: 1.4rem solid #CD68F7;
}
.bubble-1.up::after {
  content: '';

  position: absolute;

  top: -1rem;
  left: 3rem;

  width: 0;
  height: 0;

  border-left: 1rem solid transparent;
  border-right: 1rem solid transparent;
  border-bottom: 1.2rem solid rgba(64, 1, 87, 0.90);
}
.bubble-tips-1 {
  min-width: 20rem;
  padding: 1rem;
  background: rgba(64, 1, 87, 0.90);

  border-radius: 1.2rem;
  position: absolute;

  margin-left: 10rem;
  margin-top: -5rem;
  border: 0.25rem solid #CD68F7;
  color: #CD68F7;
  font-size: 2rem;
  z-index: 10
}
.bubble-tips-1.down::before {
  content: '';

  position: absolute;

  bottom: -1.4rem;
  left: 2.8rem;

  width: 0;
  height: 0;

  border-left: 1.2rem solid transparent;
  border-right: 1.2rem solid transparent;
  border-top: 1.4rem solid #CD68F7;
}
.bubble-tips-1.down::after {
  content: '';

  position: absolute;

  bottom: -1rem;
  left: 3rem;

  width: 0;
  height: 0;

  border-left: 1rem solid transparent;
  border-right: 1rem solid transparent;
  border-top: 1.2rem solid rgba(64, 1, 87, 0.90);
}

.bubble-2 {
  min-width: 20rem;
  padding: 1rem;
  background: #7B0D0D;

  border-radius: 1.2rem;
  position: absolute;

  margin-left: -15rem;
  margin-top: 13rem;

  border: 0.25rem solid #FFD78D;

  color: #FFE09C;
  font-size: 2rem;
  z-index: 10
}
.bubble-2.up::before {
  content: '';

  position: absolute;

  top: -1.4rem;
  left: 2.8rem;

  width: 0;
  height: 0;

  border-left: 1.2rem solid transparent;
  border-right: 1.2rem solid transparent;
  border-bottom: 1.4rem solid #FFD78D;
}
.bubble-2.up::after {
  content: '';

  position: absolute;

  top: -1rem;
  left: 3rem;

  width: 0;
  height: 0;

  border-left: 1rem solid transparent;
  border-right: 1rem solid transparent;
  border-bottom: 1.2rem solid #7B0D0D;
}
.bubble-tips-2 {
  min-width: 20rem;
  padding: 1rem;
  background: #7B0D0D;

  border-radius: 1.2rem;
  position: absolute;

  margin-left: 10rem;
  margin-top: -5rem;

  border: 0.25rem solid #FFD78D;

  color: #FFE09C;
  font-size: 2rem;
  z-index: 10
}
.bubble-tips-2.down::before {
  content: '';

  position: absolute;

  bottom: -1.4rem;
  left: 2.8rem;

  width: 0;
  height: 0;

  border-left: 1.2rem solid transparent;
  border-right: 1.2rem solid transparent;
  border-top: 1.4rem solid #FFD78D;
}
.bubble-tips-2.down::after {
  content: '';

  position: absolute;

  bottom: -1rem;
  left: 3rem;

  width: 0;
  height: 0;

  border-left: 1rem solid transparent;
  border-right: 1rem solid transparent;
  border-top: 1.2rem solid #7B0D0D;
}
.fullAnim {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 10;
  pointer-events: none;
}

</style>
